export const ONE_MINUTE = 60;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = 24 * ONE_HOUR;

export const DATE_LIMIT_DEFAULT_START = -31 * ONE_DAY;
export const DATE_LIMIT_DEFAULT_END = 180 * ONE_DAY;
// A full calendar year including leap years; absolute end dates are stored
// exclusive (start of the day after), so a whole-year selection spans 366 days.
export const DATE_LIMIT_MAX_RANGE = 366 * ONE_DAY;
